export default "__VITE_ASSET__KLEppok3__"